import "../utils/staleChunkReload"

require("../utils/startRailsUjs")
require("../src/application/setup")

import "./pro_experience.css"
import ReactOnRails from "react-on-rails"

import ProExperiencePage from "../pages/ProExperiencePage/ProExperiencePage"

ReactOnRails.register({ ProExperiencePage })
